import i18n from '../../i18n';
import html2canvas from 'html2canvas';

export class ScreenshotControl {
  constructor({ withLegend }) {
    this._link = document.createElement('a');
    this._withLegend = withLegend;
    this._text = { topLeft: '', bottomRight: '' };
  }
  onAdd(map) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    this._exportButton = document.createElement('button');
    this._exportButton.className = 'mapbox-gl-draw_ctrl-draw-btn v-icon notranslate mdi mdi-camera';
    this._exportButton.title = `${i18n.t('Export view')}`;
    let that = this;
    this._exportButton.addEventListener('click', () => {
      that.exportMap(this._withLegend, this._text);
    });
    this._container.appendChild(this._exportButton);
    return this._container;
  }
  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }
  setText({ topLeft, bottomRight }) {
    if (topLeft) {
      this._text.topLeft = topLeft;
    } else {
      this._text.topLeft = '';
    }
    if (bottomRight) {
      this._text.bottomRight = bottomRight;
    } else {
      this._text.bottomRight = '';
    }
  }

  exportMap(withLegend, text) {
    let mapCanvas = this._map.getCanvas();
    let mapImage = new Image(mapCanvas.width, mapCanvas.height);
    mapImage.src = mapCanvas.toDataURL('image/png');
    mapImage.onload = async function() {
      let legendCanvas;
      const domElement = document.querySelector('#legend');
      if (withLegend && domElement) {
        const positionInfo = domElement.getBoundingClientRect();
        legendCanvas = await html2canvas(domElement, {
          backgroundColor: null,
          x: positionInfo.x,
          y: positionInfo.y,
          width: positionInfo.width,
          height: positionInfo.height,
          logging: false,
          removeContainer: true,
          onclone: (document) => {
            let domElement = document.querySelector('#legend');
            domElement.style = 'visibility: visible;';
          }
        });
      }
      let onload2promise = function(obj) {
        return new Promise((resolve, reject) => {
          obj.onload = () => resolve(obj);
          obj.onerror = reject;
        });
      };

      let legendImg;
      if (legendCanvas) {
        legendImg = new Image(legendCanvas.width, legendCanvas.height);
        let legendImgPromise = onload2promise(legendImg);
        legendImg.src = legendCanvas.toDataURL('image/png');
        await legendImgPromise;
      }
      let canvas = document.createElement('canvas');
      canvas.width = mapCanvas.width;
      canvas.height = mapCanvas.height;
      let ctx = canvas.getContext('2d');
      ctx.font = '30px Arial';
      ctx.drawImage(mapImage, 0, 0);
      if (withLegend && legendImg) {
        ctx.drawImage(
          legendImg,
          mapCanvas.width - legendImg.width - 20,
          mapCanvas.height - legendImg.height - 20
        );
      }
      if (text.topLeft) {
        ctx.textAlign = 'left';
        ctx.fillText(text.topLeft, 72, 72);
      }
      if (text.bottomRight) {
        ctx.textAlign = 'center';
        let rows = text.bottomRight.split(/[\r\n]+/);
        let maxWidth = 0;
        for (let row of rows) {
          let measured = ctx.measureText(row);
          if (measured.width > maxWidth) {
            maxWidth = measured.width;
          }
        }
        let rowPosition = {
          x: mapCanvas.width - 72 - maxWidth / 2,
          y: mapCanvas.height - 72 - rows.length * 32
        };
        for (let row of rows) {
          ctx.fillText(row, rowPosition.x, rowPosition.y);
          rowPosition.y = rowPosition.y + 32;
        }
      }
      let xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function() {
        let a = document.createElement('a');
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = `${i18n.t('map')}.png`;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
        canvas.remove();
      };
      xhr.open('GET', canvas.toDataURL('image/png'));
      xhr.send();
    };
  }
}
